exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tri[data-v-3cc0d442] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n  padding: 10px 8px;\n  border-radius: 6px;\n  background: #fff;\n}\n.tri.selected .tri-label[data-v-3cc0d442] {\n  color: #1989fa;\n}\n.tri.disabled[data-v-3cc0d442] {\n  opacity: .6;\n  pointer-events: none;\n}\n.tri-icon[data-v-3cc0d442] {\n  font-size: 18px;\n  color: #1989fa;\n}\n.tri-label[data-v-3cc0d442] {\n  font-size: 14px;\n  color: #111;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3cc0d442","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mobile-ticket/ToggleRadioItem.vue
// module id = 639
// module chunks = 75